module.exports = __webpack_public_path__ + "img/latte-thumb.576a646e.png";